import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJLibrary from '../view/FJLibrary.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJLibraryContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const voiceInfo = useSelector(state => state.textToSpeech.voiceInfo);
    const languageList = useSelector(state => state.textToSpeech.languageList);
    const languageValue = useSelector(state => state.textToSpeech.languageValue);

    const voiceList = useMemo(() => {
        return FJTextToSpeechUtil.getVoiceListByLanguage(voiceInfo, languageList, languageValue);
    }, [voiceInfo, languageValue, languageList]);

    const _onLanguageValueChange = value => {
        dispatch(FJActionTextToSpeech.setSliceSpeechLanguageValueAction(value));
    };

    const _onUse = (info, options = {}) => {
        dispatch(FJActionTextToSpeech.useVoiceItemAction(info, { ...options, isAdd: true }));
    };

    return (
        <FJLibrary
            list={voiceList}
            languageList={languageList}
            onLanguageValueChange={_onLanguageValueChange}
            languageValue={languageValue}
            onUse={_onUse}
        />
    );
};

export default FJLibraryContainer;
